import AssetField from '../../../contentful/AssetField';
import {NavLink as Link} from 'react-router-dom';
import PublishStatusDot from '../../../misc/PublishStatusDot.js';
import FileAssetCollectionField from '../../../contentful/FileAssetCollectionField';
import ArticleCollectionField from '../../../contentful/ArticleCollectionField';
import cookie from 'js-cookie';

import update from 'immutability-helper';
import React from 'react';


class Generation extends React.Component {
  constructor(props) {
    super(props);
    this.handleAssetChange = this.handleAssetChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.setTabCookie = this.setTabCookie.bind(this);
  }

  componentDidMount() {
    const tab = cookie.get('mgGenerationTab');

    if (tab !== '' && tab !== undefined && document.getElementById(tab)) {
      const tabLink = document.getElementById(tab);
      tabLink.click();
    }
  }

  setTabCookie(e) {
    const tabLink = e.target.id;
    const cookieName = 'mgGenerationTab';

    cookie.set(cookieName, tabLink, {path: '/'});
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.onSave();
  }

  handleAssetChange(name, asset) {
    const change = {
      generation: {}
    };

    change.generation[name] = {
      $set: asset
    };

    const props = update(this.props, change);

    this.props.onChange(props);
  }

  handleFieldChange(e) {
    const newData = {
      generation: {}
    };

    newData.generation[e.target.name] = {
      $set: e.target.value
    };

    const props = update(this.props, newData);

    this.props.onChange(props);
  }


  render() {
    const predefinedTags = [this.props.generation.make.name];
    if (this.props.generation.name) {
      predefinedTags.push(this.props.generation.name);
    }
    if (this.props.generation.startYear === this.props.generation.endYear) {
      // Force it over into a string to be compatible with the rest of the tags.
      predefinedTags.push(`${this.props.generation.startYear}`);
    } else {
      const generationString = `${this.props.generation.startYear}-${this.props.generation.endYear}`;
      predefinedTags.push(generationString);
    }

    return (
      <section className="campaign mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li><Link to="/mypage/">Min Side</Link></li>
          <li><Link to={`/mypage/${this.props.generation.make.id}`}>{this.props.generation.make.name}</Link></li>
          <li><Link to={`/mypage/${this.props.generation.make.id}/generations/${this.props.generation.model.id}`}>Generasjoner</Link></li>
          {this.props.generation.name &&
              <li className="active">{this.props.generation.name}</li>
          }
        </ol>
        <form onSubmit={this.handleSubmit}>
          <div className="page-header">
            <div className="pull-right">
              {this.props.working &&
                <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Arbeider...&nbsp;</span>
              }
              <button
                type="submit"
                className="btn btn-default"
                disabled={!this.props.modified || this.props.working}
              >
                {Boolean(this.props.generation.id) &&
                  <span>Lagre</span>
                }
                {!this.props.generation.id &&
                  <Link
                    to={`/mypage/${this.props.generation.make.id}/generasjoner/${this.props.generation.model.id}/new`}
                    className="btn btn-success"
                    disabled={this.props.working}
                  >
                  Opprett generasjon
                  </Link>
                }
              </button>
              &nbsp;
              {this.props.onPublish &&
                <button
                  type="button"
                  className="btn btn-success"
                  disabled={(this.props.generation.published && !this.props.generation.updated) || this.props.generation.archived || this.props.working || this.props.modified}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onPublish();
                  }}
                >
                  <span>Publiser</span>
                </button>
              }
              &nbsp;
              {this.props.onUnpublish &&
                <button
                  type="button"
                  className="btn btn-warning"
                  disabled={(!this.props.generation.archived && this.props.generation.draft) || this.props.working || this.props.modified}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onUnpublish();
                    if (this.props.generation.archived) {
                      this.props.onUnarchive();
                    }
                  }}
                >
                  <span>Kladd</span>
                </button>
              }
              &nbsp;
              {this.props.onArchive &&
                <button
                  type="button"
                  className="btn btn-danger"
                  disabled={(this.props.generation.archived)}
                  onClick={(e) => {
                    e.preventDefault();
                    this.props.onArchive();
                  }}
                >
                  <span>Arkiver</span>
                </button>
              }
            </div>
            <h1>
              {this.props.generation.name} <PublishStatusDot entry={this.props.generation} /><br/>
              <small>Årsmodell {this.props.generation.startYear}-{this.props.generation.endYear}</small>
            </h1>
          </div>



          {/* Display any error message: */}
          {this.props.error &&
            <div className="alert alert-danger">
              {this.props.error}
            </div>
          }

          {/* Tabs */}
          <ul className="nav nav-tabs" role="tablist">
            <li role="general" className="active">
              <a href="#general" aria-controls="general" role="tab" id="generalTab" data-target="#general" data-toggle="tab" onClick={this.setTabCookie}>Generelt</a>
            </li>

            <li role="articles">
              <a href="#articles" aria-controls="articles" role="tab" id="articlesTab" data-target="#articles"data-toggle="tab" onClick={this.setTabCookie}>Artikler</a>
            </li>

            <li role="files">
              <a href="#files" aria-controls="files" role="tab" id="filesTab" data-target="#files" data-toggle="tab" onClick={this.setTabCookie}>Dokumenter</a>
            </li>
          </ul>

          {/* Tab content */}
          <div className="tab-content mf-margin-bottom-40">
            <div role="tabpanel" className="tab-pane active" id="general">
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <label>Årsmodell f.o.m. - t.o.m.</label>
                  <div className="form-group">
                    <div className="col-xs-3">
                      <input type="text" className="form-control" name="startYear" defaultValue={this.props.generation.startYear} disabled={this.props.working} onChange={this.handleFieldChange} />
                    </div>
                    <div className="col-xs-3">
                      <input type="text" className="form-control" name="endYear" defaultValue={this.props.generation.endYear} disabled={this.props.working} onChange={this.handleFieldChange} />
                    </div>
                  </div>
                  <br/><br/>
                  <label>Representasjonsbilde</label>
                  <div className="form-group">
                    <AssetField
                      name="listImage"
                      value={this.props.generation.listImage}
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || this.props.generation.archived}
                      predefinedTags={predefinedTags}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div role="tabpanel" className="tab-pane" id="articles">
              <div className="row">
                <div className="col-xs-12 col-md-12">
                  <div className="form-group">
                    <label>Artikler</label>
                    <ArticleCollectionField
                      name="articles"
                      value={this.props.generation.articles}
                      generationId={this.props.generation.id}
                      context="Generation"
                      contentType="articlecollection"
                      onChange={this.handleAssetChange}
                      disabled={this.props.working || this.props.generation.archived}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div role="tabpanel" className="tab-pane" id="files">
              <div className="row">
                <div className="col-xs-12 col-md-6">
                  <div className="form-group">
                    <label>Dokumenter</label>
                    <FileAssetCollectionField name="files" value={this.props.generation.files} onChange={this.handleAssetChange} disabled={this.props.working} predefinedTags={predefinedTags} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* // Tab content */}
        </form>
      </section>
    );
  }
}

Generation.defaultProps = {
  generation: null,
  modified: null,
  working: null,
  onChange: () => {},
  onSave: () => {}
};

export default Generation;
